import React from 'react'

import { connect } from 'react-redux'

import BasePureComponent from 'utils/BasePureComponent'
import request from 'utils/request'

import Button from 'components/Button'
import PolicyForm from 'components/PolicyForm'

import { VEHICLES_LIST_URL } from 'constants'

import {
  updateId,
  nextStep,
  prevStep
} from 'scenes/ClientDetail/components/AddVehicleModal/actions'
import { vehiclesFetched } from 'scenes/ClientDetail/actions'


import './style.scss'


export class PolicyDataStep extends BasePureComponent {
  constructor(props) {
    super(props)

    this.state = {
      buttonProps: {}
    }

    this._bind('_onSuccess', '_onError', '_submitForm', '_renderPolicyFormFooter')
  }

  _onSuccess(policyId) {
    request(VEHICLES_LIST_URL(this.props.clientId))
    .then(({ vehicles }) => {
      this.props.vehiclesFetched(vehicles)
    })
    this.props.updateId(policyId)
    this.props.nextStep()
  }

  _onError() {
    this.setState({
      buttonProps: {}
    })
  }


  /*
  * returns a callback that wraps the update for local-state
  * and then call the PolicyForm `submit` method.
  * we need to do it like this since PolicyForm is a react-redux connected-Component
  * and we can't access to PolicyForm methods
  * this might have it's performance downsides but there is no other way to do PolicyForm
  * 100% standalone.
  */
  _submitForm(submitForm) {
    return async (evt) => {
      evt.preventDefault()
      await this.setState({
        buttonProps: {
          disabled: true
        }
      })
      submitForm()
    }
  }

  _renderPolicyFormFooter(submitForm) {
    return (
      <div className="PolicyDataStep__footer">
        <Button
          buttonType="primary-inverse"
          onClick={this.props.prevStep}
          {...this.state.buttonProps}
        >
          Regresar
        </Button>
        <Button
          onClick={this._submitForm(submitForm)}
          {...this.state.buttonProps}
        >
          Continuar
        </Button>
      </div>
    )
  }

  render() {
    return (
      <section id="PolicyDataStep" className="PolicyDataStep">
        <div className="PolicyDataStep__top">
          <PolicyForm
            renderFooter={this._renderPolicyFormFooter}
            onError={this._onError}
            onSuccess={this._onSuccess}
            policyId={this.props.policyId}
            clientId={this.props.clientId}
            vehicleId={this.props.vehicleId}
            ref={(form) => this.policyForm = form}
            submitButton={this.submitBtn}
          />
        </div>
      </section>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    currentStep: state.addVehicleModal.get('currentStep'),
    vehicleId: state.addVehicleModal.get('vehicleId'),
    // this will be populated after creating policy on this step
    policyId: state.addVehicleModal.get('policyId')
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    nextStep: () => dispatch(nextStep()),
    prevStep: (evt) => {
      evt.preventDefault()
      dispatch(prevStep())
    },
    updateId: (id) => dispatch(updateId('policyId', id)),
    vehiclesFetched: (vehicles) => dispatch(vehiclesFetched(vehicles))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(PolicyDataStep)



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/AddVehicleModal/PolicyDataStep/index.js